import { deepPurple } from '@mui/material/colors';
import { Box, Card, Grid, Stack, useTheme, Typography } from '@mui/material';

import { useResponsive } from 'src/hooks/use-responsive';

export const DetailSessionTrackingFunction = () => {
  const theme = useTheme();
  const deepPurpleColor = deepPurple.A200;

  const smDown = useResponsive('down', 'sm');
  const mdDown = useResponsive('down', 'md');
  const padding = () => {
    if (smDown) {
      return 2;
    }
    return 3;
  };
  return (
    <Stack mb={smDown ? 5 : 10}>
      <Stack my={5} spacing={2} alignItems="center">
        <Typography
          fontFamily='"Shantell Sans Light", sans-serif'
          sx={{ color: deepPurpleColor }}
          fontSize={18}
          align="center"
          fontWeight="medium"
        >
          Phần mềm quản lý trung tâm thế hệ mới
        </Typography>
        <Typography variant="h2" align="center">
          Theo dõi buổi học dễ dàng
        </Typography>
        <Stack>
          <Typography variant="body1" align="center">
            Theo dõi tình hình học tập, lịch sử buổi học, điểm danh và nhận xét từ giáo viên ngay
            trên hệ thống.
          </Typography>
          <Typography variant="body1" align="center">
            Phần mềm quản lý trung tâm CenterUp giúp quản lý học tập dễ dàng và chính xác.
          </Typography>
        </Stack>
      </Stack>
      <Stack alignSelf="center" maxWidth={1150}>
        <Grid container justifySelf="center" spacing={4} alignItems="stretch">
          <Grid md={6} sm={12} item>
            <Card
              sx={{
                width: '100%',
                justifySelf: 'center',
                height: '100%',
                background: theme.palette.background.neutral,
                position: 'relative',
              }}
              variant="outlined"
            >
              <Stack height="100%" justifyContent="space-between">
                <Stack zIndex={2} px={padding} pt={padding}>
                  <Typography variant="h5">Nhật ký giảng dạy</Typography>
                  <Typography variant="subtitle2" fontWeight={400}>
                    Giáo viên ghi chú nội dung đã dạy, tiến độ bài học và nhận xét buổi học. Trung
                    tâm dễ dàng theo dõi hoạt động giảng dạy. Học viên có thể truy cập mọi lúc mọi
                    nơi.
                  </Typography>
                </Stack>
                <Stack>
                  <Box
                    component="img"
                    alt="employee-detail"
                    src="/assets/sub-pages/operation/session-tracking/log-teacher.png"
                    zIndex={2}
                    width="100%"
                    alignSelf="center"
                  />
                </Stack>
              </Stack>
            </Card>
          </Grid>
          <Grid md={6} sm={12} item>
            <Card
              sx={{
                width: '100%',
                justifySelf: 'center',
                height: '100%',
                background: theme.palette.background.neutral,
              }}
              variant="outlined"
            >
              <Stack height="100%" justifyContent="space-between">
                <Stack px={padding} pt={padding}>
                  <Typography variant="h5">Nhận xét riêng cho từng học viên</Typography>
                  <Typography variant="subtitle2" fontWeight={400}>
                    Giáo viên nhận xét riêng từng học viên sau mỗi buổi học
                  </Typography>
                </Stack>{' '}
                <Stack>
                  <Box
                    alignSelf="flex-end"
                    alt="class-dashboard"
                    component="img"
                    width="100%"
                    src="/assets/sub-pages/operation/session-tracking/log-student.png"
                    zIndex={2}
                  />
                </Stack>
              </Stack>
            </Card>
          </Grid>
          <Grid md={6} sm={12} item>
            <Card
              sx={{
                width: '100%',
                justifySelf: 'center',
                height: '100%',
                background: theme.palette.background.neutral,
              }}
              variant="outlined"
            >
              <Stack height="100%" justifyContent="space-between">
                <Stack px={padding} pt={padding}>
                  <Typography variant="h5">Phân công & nhiệm vụ liên quan</Typography>
                  <Typography variant="subtitle2" fontWeight={400}>
                    Quản lý giáo viên giảng dạy, phân công công việc liên quan đến buổi học. Theo
                    dõi tiến độ xử lý và trách nhiệm từng cá nhân.
                  </Typography>
                </Stack>
                <Stack>
                  <Box
                    component="img"
                    alt="class-task"
                    src="/assets/sub-pages/operation/session-tracking/task.png"
                    zIndex={2}
                    width="100%"
                    alignSelf="center"
                  />
                </Stack>
              </Stack>
            </Card>
          </Grid>
          <Grid md={6} sm={12} item>
            <Card
              sx={{
                width: '100%',
                justifySelf: 'center',
                height: '100%',
                background: theme.palette.background.neutral,
              }}
              variant="outlined"
            >
              <Stack height="100%" justifyContent="space-between">
                <Stack px={padding} pt={padding} width={1}>
                  <Typography variant="h5">Lưu trữ video ghi hình</Typography>
                  <Typography variant="subtitle2" fontWeight={400}>
                    Lưu trữ video học tập, link học online, video ghi lại. Học viên dễ dàng truy cập
                  </Typography>
                </Stack>
                <Stack>
                  <Box
                    component="img"
                    alt="class-schedule"
                    src="/assets/sub-pages/operation/session-tracking/store-video.png"
                    zIndex={2}
                    width="100%"
                    alignSelf="center"
                  />
                </Stack>
              </Stack>
            </Card>
          </Grid>
          <Grid md={6} sm={12} item>
            <Card
              sx={{
                width: '100%',
                justifySelf: 'center',
                height: '100%',
                background: theme.palette.background.neutral,
              }}
              variant="outlined"
            >
              <Stack height="100%" justifyContent="space-between">
                <Stack px={padding} pt={padding} width={1}>
                  <Typography variant="h5">Báo cáo tổng quan buổi học</Typography>
                  <Typography variant="subtitle2" fontWeight={400}>
                    Tự động thống kê số học viên – giáo viên tham gia, học phí ghi nhận và điểm đánh
                    giá buổi học.
                  </Typography>
                </Stack>
                <Stack>
                  <Box
                    component="img"
                    alt="class-schedule"
                    src="/assets/sub-pages/operation/session-tracking/report.png"
                    zIndex={2}
                    width="100%"
                    alignSelf="center"
                  />
                </Stack>
              </Stack>
            </Card>
          </Grid>
          <Grid md={6} sm={12} item>
            <Card
              sx={{
                width: '100%',
                justifySelf: 'center',
                height: '100%',
                background: theme.palette.background.neutral,
              }}
              variant="outlined"
            >
              <Stack height="100%" justifyContent="space-between">
                <Stack px={padding} pt={padding} width={1}>
                  <Typography variant="h5">Tài liệu & Bài tập liên quan</Typography>
                  <Typography variant="subtitle2" fontWeight={400}>
                    Quản lý tài liệu dành riêng cho giáo viên hoặc tài liệu gửi học viên trong buổi
                    học. Học viên dễ dàng truy cập để học tập.
                  </Typography>
                </Stack>
                <Stack>
                  <Box
                    component="img"
                    alt="class-schedule"
                    src="/assets/sub-pages/operation/session-tracking/documents.png"
                    zIndex={2}
                    width="100%"
                    alignSelf="center"
                  />
                </Stack>
              </Stack>
            </Card>
          </Grid>
        </Grid>
      </Stack>
    </Stack>
  );
};
